<template>
    <rkm-modal
        :loading="loading"
        large
        ref="RkmModal"
        title="Confirmação de óbito"
        v-if="data.form"
    >

    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-col cols="12">
            Ao registrar o óbito, o paciente deixará de ser considerado o responsável familiar,
            sendo necessário indicar outro membro da família para assumir essa responsabilidade.
        </rkm-col>

        <rkm-col cols="12" class="mt-3">
            <rkm-form-select
                :options="residentes"
                label="Novo responsável familiar"
                show-default-option
                text-field="nome"
                v-model="data.model.responsavelCidadaoId"
                default-option-text="Selecione"
                value-field="id"
                :validations="validations.responsavelFamiliar"
            />
        </rkm-col>
    </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="handleCancel()">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="handleRegister()"
                color="primary"
            >
                Registrar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

export default {
    computed: {
        validations() {

            return {
                responsavelFamiliar: { required: true },
            }
        },
        residentes() {

            return this.data.form.residentes && this.data.form.residentes.length > 0
                ? this.data.form.residentes.filter(item => item.pacienteId != this.data.model.id) : []
        }
    },
    data: () => ({
        loading: false,
        model: {},
    }),
    methods: {
        async validate() {

            return this.$refs.RkmModal.validate()
        },
        open() {
            this.$refs.RkmModal.show()
        },
        handleCancel() {

            this.data.model.saidaCidadaoId = null

            this.$refs.RkmModal.hide()
        },
        handleRegister() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                this.data.model.responsavelUsuario = null
                this.data.model.responsavelData = null
                this.data.model.responsavelEquipeId = null
                this.data.model.responsavelInfraestruturaId = null
                this.data.model.responsavelOcupacaoId = null
                this.data.model.responsavelUnidadeId = null
                this.data.model.responsavel = false

                if (this.data.form.responsaveis.length == 0) {

                    const responsavel = this.data.form.residentes.find(responsavel =>
                        responsavel.id == this.data.model.responsavelCidadaoId)

                    this.data.form.responsaveis.push(responsavel)
                }

                this.$refs.RkmModal.hide()
            })
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>